import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_TOTAL_MERCADERIA_GRADO_3 } from '../../../../config/tables'

function TablaLiquidacionMercaderiaGrado3View () {
  return (
    <MuiTable id={TABLA_TOTAL_MERCADERIA_GRADO_3} />
  )
}

export default TablaLiquidacionMercaderiaGrado3View
